/**
 * 运单列表页面路径
 */
export const WAYBILL_LIST_PAGE_PATH = '/waybill/list'
